module.exports = __webpack_public_path__ + "static/media/undraw_not_found.3c5087f1.png";